import { RootState } from '../reducers';
import { JwtToken } from '@unitedtraders/keycloak';
import { createSelector } from 'reselect';
import jwtDecode from 'jwt-decode';

export const root = (state: RootState) => state.app;

export const location = (state: RootState) => state.router;

export const tokensLastUpdate = (state: RootState) => root(state).tokensTouched;
export const currentUserId = createSelector(
  (state: RootState) => state.app.accessToken,
  (token) => {
    if (!token) {
      return;
    }
    const result = jwtDecode<Token>(token);
    return result.user_id;
  }
);
export const isAuthenticated = (state: RootState) => ({
  isAuthenticated: !!root(state).accessToken,
});
export const version = (state: RootState) => root(state).version;
export const metadataSelector = (state: RootState) => root(state).metadata;
export const languageSelector = (state: RootState) => root(state).language;

interface Token extends JwtToken {
  user_id: string;
  realm_access: {
    roles: string[];
  };
}

export const rolesSelector = createSelector(
  (state: RootState) => state.app.accessToken,
  (token) => {
    if (!token) {
      return { userRoles: [] };
    }
    const result = jwtDecode<Token>(token);
    return { userRoles: result.realm_access.roles || [] };
  }
);
